webpackJsonp([2],{

/***/ 206:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'info',
	data: function data() {
		return {
			videos: []
		};
	},

	beforeDestroy: function beforeDestroy() {
		if (this.$root && this.$root.closeMenu) {
			this.$root.closeMenu();
		}
	}
});

/***/ }),

/***/ 210:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(63)(true);
// imports


// module
exports.push([module.i, ".info{background-color:#fff;padding:25px;text-align:left;color:#222;line-height:1.5;-webkit-box-shadow:0 3px 15px rgba(0,0,0,.31);box-shadow:0 3px 15px rgba(0,0,0,.31);margin-bottom:150px}.info h1{font-family:Freckle Face,cursive;font-weight:400!important;margin-top:0;background-color:#666;color:#fff;padding:25px;padding-bottom:10px;margin-left:-25px;margin-top:-25px;margin-right:-25px}.info p{font-family:Open Sans,sans-serif}", "", {"version":3,"sources":["/home/matteo/development/garadirutti/pwa-gdr/src/components/info.vue"],"names":[],"mappings":"AACA,MACE,sBAAwB,AACxB,aAAc,AACd,gBAAiB,AACjB,WAAY,AACZ,gBAAiB,AACjB,8CAAmD,AAC3C,sCAA2C,AACnD,mBAAqB,CACtB,AACD,SACE,iCAAqC,AACrC,0BAA4B,AAC5B,aAAc,AACd,sBAAuB,AACvB,WAAa,AACb,aAAc,AACd,oBAAqB,AACrB,kBAAmB,AACnB,iBAAkB,AAClB,kBAAoB,CACrB,AACD,QACE,gCAAqC,CACtC","file":"info.vue","sourcesContent":["\n.info {\n  background-color: white;\n  padding: 25px;\n  text-align: left;\n  color: #222;\n  line-height: 1.5;\n  -webkit-box-shadow: 0 3px 15px rgba(0, 0, 0, 0.31);\n          box-shadow: 0 3px 15px rgba(0, 0, 0, 0.31);\n  margin-bottom: 150px;\n}\n.info h1 {\n  font-family: 'Freckle Face', cursive;\n  font-weight: 400 !important;\n  margin-top: 0;\n  background-color: #666;\n  color: white;\n  padding: 25px;\n  padding-bottom: 10px;\n  margin-left: -25px;\n  margin-top: -25px;\n  margin-right: -25px;\n}\n.info p {\n  font-family: 'Open Sans', sans-serif;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 216:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(210);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(64)("17c555f1", content, true, {});

/***/ }),

/***/ 237:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "infoLayout mainLayout"
  }, [_c('section', {
    staticClass: "info"
  }, [_c('h1', [_vm._v("Maggiori informazioni")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "info-tech"
    }
  }, [_vm._v("Tecnologie")]), _vm._v(" "), _c('h3', [_vm._v("PWA")]), _vm._v(" "), _c('p', [_vm._v("Questo sito è una "), _c('a', {
    attrs: {
      "href": "https://developers.google.com/web/progressive-web-apps/",
      "target": "_blank"
    }
  }, [_vm._v("PWA")]), _vm._v("\n\t\tcome definito da Google ultimamente, ossia è una applicazione web con funzionalità aggiuntive:")]), _vm._v(" "), _c('p', [_c('ul', [_c('li', [_vm._v("Funziona offline (parzialmenmte: i video non sono visibili da youtuibe mentre si è offline, ma si possono vedere l'elenco dei video e le loro miniature)")]), _vm._v(" "), _c('li', [_vm._v("Puo essere \"installata\" sul device attraverso la funzionalita \"add to homescreen\"")]), _vm._v(" "), _c('li', [_vm._v("Permette di essere caricata piu' velocemente")])])]), _vm._v(" "), _c('p', [_vm._v("Nota: \n\t\t\tla disponibilita' dei contenuti offline dipende anche dal browser in uso: consiglio di usare Chrome, \n\t\t\tOpera o Firefox alle ultime versioni per usufruire al meglio dei contenuti.\n\t\t")]), _vm._v(" "), _c('h3', [_vm._v("JAM")]), _vm._v(" "), _c('p', [_vm._v("Inotre utilizza lo stack JAM che consiste in 3 principali componenti:")]), _vm._v(" "), _c('p', [_c('ol', [_c('li', [_c('strong', [_vm._v("J")]), _vm._v(": javascript come linguaggio base")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("A")]), _vm._v(": API per passare informazioni ed interagire con la piattaforma")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("M")]), _vm._v(": Markup per creare i template che state vedendo")])])]), _vm._v(" "), _c('h3', [_vm._v("Hosting e sviluppo")]), _vm._v(" "), _c('p', [_vm._v("Questa web app è resa disponibile grazie a:")]), _vm._v(" "), _c('p', [_c('ol', [_c('li', [_c('strong', [_vm._v("Vuejs")]), _vm._v(": Framework javascript - "), _c('a', {
    attrs: {
      "href": "https://vuejs.org/",
      "target": "_blank"
    }
  }, [_vm._v("link")])]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Webpack")]), _vm._v(": Bundler javascript - "), _c('a', {
    attrs: {
      "href": "https://webpack.github.io/",
      "target": "_blank"
    }
  }, [_vm._v("link")])]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Netlify")]), _vm._v(": Hosting html e file statici - "), _c('a', {
    attrs: {
      "href": "https://www.netlify.com/",
      "target": "_blank"
    }
  }, [_vm._v("link")])]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Firebase Realtime db")]), _vm._v(": database usato per mostrare i video aggiunti dalla community - "), _c('a', {
    attrs: {
      "href": "https://firebase.google.com/",
      "target": "_blank"
    }
  }, [_vm._v("link")])]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Firebase Cloud functions")]), _vm._v(": API permettere l'interazione con la web application: voti e aggiunta di video - "), _c('a', {
    attrs: {
      "href": "https://firebase.google.com/",
      "target": "_blank"
    }
  }, [_vm._v("link")])])])])])])
}]}

/***/ }),

/***/ 68:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(216)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(206),
  /* template */
  __webpack_require__(237),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

});


// WEBPACK FOOTER //
// static/js/2.50de0598538e3ea856ba.js